const deal = {
  id: null,
  name: null,
  notes: null,
  createdBy: null,
  createdByName: null,
  updatedBy: null,
  updatedByName: null,
  createdAt: null,
  updatedAt: null,
  statusId: null,
  dealSummary: null,
  dealClientId: null,
  dealClientName: null,
  dealCandidateId: null,
  dealCandidateFirstName: null,
  dealCandidateLastName: null,
  dealAssignmentId: null,
  dealAssignmentType: null,
  dataMissingTasks: false,
  dealCreationTypeId: null,
  zrJobOpeningId: null
}

export default () => Object.assign({}, deal)
